import React from 'react'
import PlaceholderCraftBlock from './placeholder-blocks/PlaceholderCraftBlock';
import MyHubCardList from './MyHubCardList';

const DashboardCraftBlocks = ({items}) => {
  return (
    <div className='dashboard-crafts'>
      {!items || !items.predictions.length ? (
          <PlaceholderCraftBlock type="prediction" />
        ) : (
          <MyHubCardList
            title="My Predictions"
            list={items.predictions}
            link="/inventory/predictions"
          />
        )}
        {!items || !items.identities.length ? (
          <PlaceholderCraftBlock type="identity" />
        ) : (
          <MyHubCardList
            title="My Identities"
            list={items.identities}
            link="/inventory/identities"
          />
        )}
    </div>
  )
}

export default DashboardCraftBlocks;
